<template>
    <div class="container admin-submenu-page admin-botones-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap botones-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap botones-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="component-select"
                        v-model="selectedComponent"
                        @change="onComponentChange(); controlsTableItems = []; fgl_consulta = false"
                        class="filter-select"
                        :disabled="loadingRoles"
                    >
                        <b-form-select-option :value="null">
                            {{ labels.selectComponentOption }}
                        </b-form-select-option>
                        <option v-for="component in componentOptions" :key="component.value" :value="component.value">
                            {{ component.text }}
                        </option>
                    </b-form-select>
                    
                    <b-form-select
                        id="role-select"
                        v-model="selectedRole"
                        @change="controlsTableItems = []; fgl_consulta = false"
                        class="filter-select ml-2"
                        :disabled="loadingRoles"
                    >
                        <b-form-select-option :value="null">
                            {{ labels.selectRoleOption }}
                        </b-form-select-option>
                        <option v-for="rol in roleOptions" :key="rol.value" :value="rol.value">
                            {{ rol.text }}
                        </option>
                    </b-form-select>
                    
                    <b-button
                        class="consult-btn ml-2"
                        @click="consultarDatos()"
                        :disabled="!selectedComponent || !selectedRole || loadingRoles"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :items="controlsTableItems"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <!-- Espacio para futuras acciones -->
                        </div>
                    </template>

                    <template #cell(control)="data">
                        <div class="text-left">{{ data.item?.control }}</div>
                    </template>

                    <template #cell(descripcion)="data">
                        <div class="text-left">{{ data.item?.descripcion }}</div>
                    </template>

                    <template #cell(accionToggle)="data">
                        <b-button
                            v-if="data.item?.estado == true"
                            variant="link"
                            class="p-0 border-0 shadow-none"
                            @click="toggleControl(data.item?.control, false)"
                            :disabled="!showToolbarExtras"
                        >
                            <i><font-awesome-icon :icon="['fas', 'toggle-on']" size="xl"/></i>
                        </b-button>
                        <b-button
                            v-else
                            variant="link"
                            class="p-0 border-0 shadow-none"
                            @click="toggleControl(data.item?.control, true)"
                            :disabled="!showToolbarExtras"
                        >
                            <i><font-awesome-icon :icon="['fas', 'toggle-off']" size="xl"/></i>
                        </b-button>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import BotonesControl from "../../services/BotonesControl" 
import Roles from "../../services/Roles" 
import CorporateDataTable from "../utils/CorporateDataTable.vue"

const CONTROL_CONFIG = {
    BalanceNiif: {
        scope: "BALNIIF",
        label: "Balance NIIF",
        controls: [
            { key: "Balance", id_boton: 100, label: "Checkbox Balance" },
            { key: "Comparativo", id_boton: 200, label: "Checkbox Comparativo" },
            { key: "Consolidado", id_boton: 300, label: "Checkbox Consolidado" },
            { key: "Notas", id_boton: 400, label: "Checkbox Notas" },
            { key: "Informacion", id_boton: 500, label: "Checkbox Información" },
            { key: "SelectorMoneda", id_boton: 600, label: "Mostrar selector de moneda" },
            { key: "SelectorMonedaConsolidado", id_boton: 630, label: "Mostrar selector de moneda (Consolidado)" },
            { key: "MonedaFuncional1", id_boton: 610, label: "Permitir moneda funcional 1" },
            { key: "MonedaFuncional2", id_boton: 620, label: "Permitir moneda funcional 2" }
        ]
    },
    ReporteECP: {
        scope: "REPORTEECP",
        label: "Reporte ECP",
        controls: [
            { key: "Consolidado", id_boton: 300, label: "Checkbox Consolidado" },
            { key: "Reporte", id_boton: 700, label: "Checkbox Reporte" },
            { key: "ReporteConsol", id_boton: 710, label: "Checkbox Reporte Consol" },
            { key: "Informacion", id_boton: 720, label: "Checkbox Valor Manual" },
            { key: "InfAjusteConsol", id_boton: 730, label: "Checkbox Ajuste Consol" },
            { key: "InfAjusteComb", id_boton: 740, label: "Checkbox Ajuste Combinado" },
            { key: "Empresas", id_boton: 750, label: "Checkbox Empresas" },
            { key: "EmpresasReporte", id_boton: 760, label: "Checkbox Empresas Reporte" },
            { key: "SelectorMoneda", id_boton: 600, label: "Mostrar selector de moneda" },
            { key: "MonedaFuncional1", id_boton: 610, label: "Permitir moneda funcional 1" },
            { key: "MonedaFuncional2", id_boton: 620, label: "Permitir moneda funcional 2" }
        ]
    },
    ReporteEFE: {
        scope: "REPORTEEFE",
        label: "Reporte EFE",
        controls: [
            { key: "Consolidado", id_boton: 300, label: "Checkbox Consolidado" },
            { key: "Informacion", id_boton: 720, label: "Checkbox Valor Manual" },
            { key: "InfAjusteConsol", id_boton: 730, label: "Checkbox Ajuste Consol" },
            { key: "InfAjusteComb", id_boton: 740, label: "Checkbox Ajuste Combinado" },
            { key: "Nivel1", id_boton: 810, label: "Checkbox Nivel 1" },
            { key: "Nivel2", id_boton: 820, label: "Checkbox Nivel 2" },
            { key: "Nivel3", id_boton: 830, label: "Checkbox Nivel 3" },
            { key: "Nivel4", id_boton: 840, label: "Checkbox Nivel 4" },
            { key: "Empresas", id_boton: 750, label: "Checkbox Empresas" },
            { key: "SelectorMoneda", id_boton: 600, label: "Mostrar selector de moneda" },
            { key: "MonedaFuncional1", id_boton: 610, label: "Permitir moneda funcional 1" },
            { key: "MonedaFuncional2", id_boton: 620, label: "Permitir moneda funcional 2" }
        ]
    },
    ReporteORI: {
        scope: "REPORTEORI",
        label: "Reporte ORI",
        controls: [
            { key: "Consolidado", id_boton: 300, label: "Checkbox Consolidado" },
            { key: "Reporte", id_boton: 700, label: "Checkbox Reporte" },
            { key: "Informacion", id_boton: 720, label: "Checkbox Valor Manual" },
            { key: "AjusteConsol", id_boton: 730, label: "Checkbox Ajuste Consol" },
            { key: "AjusteCombinado", id_boton: 740, label: "Checkbox Ajuste Combinado" },
            { key: "Empresas", id_boton: 750, label: "Checkbox Empresas" },
            { key: "SelectorMoneda", id_boton: 600, label: "Mostrar selector de moneda" },
            { key: "MonedaFuncional1", id_boton: 610, label: "Permitir moneda funcional 1" },
            { key: "MonedaFuncional2", id_boton: 620, label: "Permitir moneda funcional 2" }
        ]
    },
    FlujoCaja: {
        scope: "FLUJOCAJA",
        label: "Flujo de Caja",
        controls: [
            { key: "Nivel1", id_boton: 810, label: "Checkbox Nivel 1" },
            { key: "Nivel2", id_boton: 820, label: "Checkbox Nivel 2" },
            { key: "Nivel3", id_boton: 830, label: "Checkbox Nivel 3" },
            { key: "Nivel4", id_boton: 840, label: "Checkbox Nivel 4" },
            { key: "MetodoDirecto", id_boton: 850, label: "Método Directo" },
            { key: "MetodoIndirecto", id_boton: 860, label: "Método Indirecto" }
        ]
    }
}

export default {
    name: 'ButtonAdminPanel',
    components: {
        CorporateDataTable
    },
    
    data() {
        return {
            fgl_consulta: false,
            selectedComponent: null,
            selectedRole: null,
            roles: [],
            componentControls: {},
            originalControls: {},
            hasChanges: false,
            loadingControls: false,
            loadingRoles: false,
            isLoading: false,
            loadRequestId: 0,
            controlsTableItems: [],
            listDataOrigen: []
        }
    },
    
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Panel de Control de Componentes",
                    selectComponent: "Seleccionar Componente",
                    selectComponentOption: "Seleccione un componente",
                    selectRole: "Seleccionar Rol",
                    selectRoleOption: "Seleccione un rol",
                    controlsFor: "Controles para",
                    role: "Rol",
                    loading: "Cargando controles...",
                    selectMessage: "Seleccione un componente y un rol para configurar sus controles",
                    successMessage: "Controles guardados exitosamente",
                    errorMessage: "Error al guardar controles",
                    warningMessage: "No fue posible cargar controles desde la base de datos. Se usan valores locales.",
                    roleErrorMessage: "No fue posible cargar roles",
                    control: "Control",
                    description: "Descripción",
                    estado: "Estado",
                    consultar: "Consultar",
                    edit: "Editar",
                    delete: "Eliminar",
                    clear: "Limpiar",
                    showing: "Mostrando",
                    of: "de",
                    records: "registros",
                    noData: "No hay datos disponibles",
                    noResults: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterControl: "Filtrar control...",
                    filterDescription: "Filtrar descripción..."
                }
            } else {
                return {
                    title: "Component Control Panel",
                    selectComponent: "Select Component",
                    selectComponentOption: "Select a component",
                    selectRole: "Select Role",
                    selectRoleOption: "Select a role",
                    controlsFor: "Controls for",
                    role: "Role",
                    loading: "Loading controls...",
                    selectMessage: "Select a component and a role to configure its controls",
                    successMessage: "Controls saved successfully",
                    errorMessage: "Error saving controls",
                    warningMessage: "Could not load controls from database. Using local values.",
                    roleErrorMessage: "Could not load roles",
                    control: "Control",
                    description: "Description",
                    estado: "Status",
                    consultar: "Consult",
                    edit: "Edit",
                    delete: "Delete",
                    clear: "Clear",
                    showing: "Showing",
                    of: "of",
                    records: "records",
                    noData: "No data available",
                    noResults: "No results found",
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    filterControl: "Filter control...",
                    filterDescription: "Filter description..."
                }
            }
        },
        
        componentOptions() {
            return Object.keys(CONTROL_CONFIG)?.map((componentName) => ({
                value: componentName,
                text: CONTROL_CONFIG[componentName].label 
            }))
        },
        
        roleOptions() {
            return this.roles.map((rol) => ({
                value: Number(rol.id), 
                text: `${rol.nombre} (${rol.id})` 
            }))
        },
        
        showToolbarExtras() {
            return this.fgl_consulta
        },
        
        showSearchTable() {
            return true
        },
        
        allFields() {
            return [
                { key: 'control', label: this.labels.control, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'descripcion', label: this.labels.description, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'accionToggle', label: this.labels.estado, sortable: false, thClass: 'text-center', tdClass: 'text-center align-middle' }
            ]
        },
        
        tableFilterDefs() {
            return [
                { key: 'control', type: 'text', placeholder: this.labels.filterControl },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescription }
            ]
        },
        
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noResults,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    
    methods: {
        goBack() {
            this.$router.back()
        },
        
        async loadRoles() {
            this.loadingRoles = true
            try {
                const response = await Roles.getAllRoles() 
                const roles = Array.isArray(response.data.roles) ? response.data.roles : [] 
                this.roles = roles
                this.selectedRole = null
            } catch (error) {
                console.error("Error cargando roles:", error) 
                this.$toast.error(this.labels.roleErrorMessage)
            } finally {
                this.loadingRoles = false
            }
        },
        
        onComponentChange() {
            this.controlsTableItems = []
            this.fgl_consulta = false
        },
        
        getComponentDefinition() {
            return CONTROL_CONFIG[this.selectedComponent] || null
        },
        
        getDefaultControls(componentName) {
            const definition = CONTROL_CONFIG[componentName]
            if (!definition) return {}
            return definition.controls?.reduce((acc, item) => {
                acc[item.key] = true 
                return acc
            }, {})
        },
        
        async loadComponentControls() {
            if (!this.selectedComponent || !this.selectedRole) return
            
            const requestId = ++this.loadRequestId
            const definition = this.getComponentDefinition()
            const defaults = this.getDefaultControls(this.selectedComponent)
            const baseControls = { ...defaults } 
            
            this.isLoading = true
            try {
                const roleId = Number(this.selectedRole) || 0
                const response = await BotonesControl.getBotonesControl(definition.scope, roleId) 
                if (requestId !== this.loadRequestId) return
                
                const botones = Array.isArray(response.data.botones) ? response.data.botones : [] 
                const nextControls = { ...baseControls } 
                
                definition.controls.forEach((item) => { 
                    const fromDb = botones.find((boton) => Number(boton.id_boton) === item.id_boton) 
                    if (fromDb) {
                        nextControls[item.key] = fromDb.enabled !== false 
                    }
                })
                
                this.componentControls = { ...nextControls }
                this.originalControls = { ...nextControls }
                this.hasChanges = false
                
                this.controlsTableItems = definition.controls.map((control) => ({
                    control: control.key,
                    descripcion: control.label,
                    estado: this.componentControls[control.key] === true,
                    id_boton: control.id_boton
                }))
                
                this.fgl_consulta = true
                
            } catch (error) {
                if (requestId !== this.loadRequestId) return
                console.error('Error cargando controles:', error) 
                this.componentControls = { ...baseControls }
                this.originalControls = { ...baseControls }
                this.hasChanges = false
                
                this.controlsTableItems = definition.controls.map((control) => ({
                    control: control.key,
                    descripcion: control.label,
                    estado: this.componentControls[control.key] === true,
                    id_boton: control.id_boton
                }))
                
                this.fgl_consulta = true
                this.$toast.warning(this.labels.warningMessage)
            } finally {
                if (requestId === this.loadRequestId) {
                    this.isLoading = false
                }
            }
        },
        
        consultarDatos() {
            if (!this.selectedComponent || !this.selectedRole) {
                this.$toast.error('Seleccione un componente y un rol para consultar.')
                return
            }
            this.loadComponentControls()
        },
        
        async toggleControl(controlName, enabled) {
            if (!controlName || !this.fgl_consulta) return
            
            this.componentControls[controlName] = !!enabled
            this.hasChanges = true
            
            const definition = this.getComponentDefinition()
            if (definition) {
                this.controlsTableItems = definition.controls.map((control) => ({
                    control: control.key,
                    descripcion: control.label,
                    estado: this.componentControls[control.key] === true,
                    id_boton: control.id_boton
                }))
            }
            
            await this.saveAllControls()
        },
        
        async saveAllControls() {
            if (!this.selectedComponent || !this.selectedRole || !this.hasChanges) return
            
            const definition = this.getComponentDefinition()
            if (!definition) return
            
            this.isLoading = true
            const botones = definition.controls.map((control) => ({ 
                id_boton: control.id_boton, 
                enabled: this.componentControls[control.key] === true
            }))
            
            try {
                await BotonesControl.saveBotonesControl( 
                    definition.scope, 
                    botones,
                    this.$store.state.userId,
                    this.selectedRole
                )
                
                this.originalControls = { ...this.componentControls }
                this.hasChanges = false
                this.$toast.success(this.labels.successMessage)
            } catch (error) {
                console.error('Error guardando controles:', error) 
                this.$toast.error(this.labels.errorMessage)
                this.componentControls = { ...this.originalControls }
            } finally {
                this.isLoading = false
            }
        }
    },
    
    mounted() {
        this.selectedComponent = null
        this.loadRoles()
    },
    
    watch: {
        selectedRole(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.controlsTableItems = []
                this.fgl_consulta = false
                this.componentControls = {}
            }
        },
        selectedComponent(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.controlsTableItems = []
                this.fgl_consulta = false
                this.componentControls = {}
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.botones-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.botones-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.botones-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.botones-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.botones-header .consult-btn:hover,
.botones-header .consult-btn:focus,
.botones-header .consult-btn:active,
.botones-header .consult-btn:not(:disabled):hover,
.botones-header .consult-btn:not(:disabled):focus,
.botones-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.botones-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
    .botones-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }
    
    .botones-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .botones-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }
    
    .botones-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }
    
    .botones-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }
    
    .botones-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }
    
    .botones-header .filters-container {
        gap: 4px;
    }
    
    .botones-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>